module.exports = __webpack_public_path__ + "img/role02.7422f77a.png";